import React from "react";

export default function StatusBadge({ found }) {
  return (
    <span className={`badge rounded-pill fs-6 ${found ? "text-bg-success" : "text-bg-danger"}`}>
      {found ? "Record Found" : "Record Not Found"}
    </span>
  );
}
